
import { Component, Inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  NavigationEnd,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { DialogService } from '@ay-gosu/ui/dialog';
import { ConnectionService } from '../connection.service';
import { IBackstageLoginService, LOGIN_SERVICE } from './login.service';

@Component({
    selector: 'gosu-login',
    imports: [
    MatCardModule,
    MatProgressBarModule,
    RouterOutlet,
    RouterModule,
    MatProgressSpinnerModule
],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    host: {
        class: 'flex h-full bg-[#F7F9FC] items-center overflow-y-auto',
    }
})
export class LoginComponent {
  public constructor(
    @Inject(LOGIN_SERVICE)
    public readonly loginService: IBackstageLoginService,
    public readonly connectionService: ConnectionService,
    private readonly _router: Router,
    private readonly _dialogService: DialogService,
  ) {
    this._router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) return;
      this._updateBodyClass(event.url);
    });
    this._updateBodyClass(this._router.url);
  }

  private _updateBodyClass(url: string) {
    const inLoginPage = url.startsWith('/login');
    if (inLoginPage) {
      window.document.body.classList.add('gosu');
    } else {
      window.document.body.classList.remove('gosu');
    }
  }
}
